import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
    providedIn: 'root'
})
export class StorageService {
    private secretKey = 'eLf-secure-storage-key-12345'; // In a real app, this might come from a protected env config

    constructor() { }

    /**
     * Encrypt and save data to sessionStorage
     */
    saveSecureData(key: string, value: any): void {
        const dataStr = typeof value === 'string' ? value : JSON.stringify(value);
        // const encryptedData = CryptoJS.AES.encrypt(dataStr, this.secretKey).toString();
        // sessionStorage.setItem(key, encryptedData);
        sessionStorage.setItem(key, dataStr);
    }

    /**
     * Get and decrypt data from sessionStorage
     */
    getSecureData(key: string): any {
        const data = sessionStorage.getItem(key);
        if (!data) return null;

        try {
            // Try to parse as JSON first
            return JSON.parse(data);
        } catch (e) {
            // If parsing fails, return as string
            return data;
        }

        // Encrypted version for reference/rollback
        /*
        const encryptedData = sessionStorage.getItem(key);
        if (!encryptedData) return null;

        try {
            const bytes = CryptoJS.AES.decrypt(encryptedData, this.secretKey);
            const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

            try {
                return JSON.parse(decryptedData);
            } catch (e) {
                return decryptedData;
            }
        } catch (e) {
            // decryption failed — clear corrupted data
            this.clearAll();
            return null;
        }
        */
    }

    /**
     * Remove specific item
     */
    removeItem(key: string): void {
        sessionStorage.removeItem(key);
    }

    /**
     * Clear all session data
     */
    clearAll(): void {
        sessionStorage.clear();
    }
}
